export interface ICompanyLogo {
    sync_key?: string;
    sync_last?: string;
    web_setting_id?: string;
    web_setting_value?: string;
    web_setting_value_file?: File;
    web_setting_value_file_original?: File;
}
